import { ASSETS_BASE_URL } from '@/assets.js';

const team_member = {

    brock_wester: {
        name: "Brock Wester",
        public: true,
        id: "brock_wester",
        hero: (ASSETS_BASE_URL + "team/brock_wester.jpg"),
        title: "Project Manager",
        email: "",
        github: "https://github.com/BrockWester"
    },

    will_gray_roncal: {
        name: "William Gray-Roncal",
        public: true,
        id: "will_gray_roncal",
        hero: (ASSETS_BASE_URL + "team/WRGR_Headshot.jpg"),
        title: "Project Manager",
        email: "",
        github: "https://github.com/wrgr"
    },

    sandy_hider: {
        name: "Sandy Hider",
        public: true,
        id: "sandy_hider",
        hero: (ASSETS_BASE_URL + "team/sandy.jpg"),
        title: "Lead Software Engineer",
        email: "",
        github: "https://github.com/sandyhider"
    },

    tim_gion: {
        name: "Tim Gion",
        public: true,
        id: "tim_gion",
        hero: (ASSETS_BASE_URL + "team/tim_gion.jpg"),
        title: "Software Engineer",
        email: "",
        github: "https://github.com/movestill"
    },

    jordan_matelsky: {
        name: "Jordan Matelsky",
        public: true,
        id: "jordan_matelsky",
        hero: (ASSETS_BASE_URL + "team/mateljk1_LThumb.jpg"),
        title: "Software Engineer",
        email: "",
        github: "https://github.com/j6k4m8"
    },

    daniel_xenes: {
        name: "Daniel Xenes",
        public: true,
        id: "daniel_xenes",
        hero: (ASSETS_BASE_URL + "team/daniel.jpg"),
        title: "Research Engineer",
        email: "",
        github: "https://github.com/dxenes1"
    },

    hannah_gooden: {
        name: "Hannah (Gooden) Martinez",
        public: true,
        id: "hannah_gooden",
        hero: (ASSETS_BASE_URL + "team/hannah.jpg"),
        title: "Software Engineer",
        email: "",
        github: "https://github.com/hannah-martinez"
    },

    nicole_stock: {
        name: "Nicole Tregoning",
        public: true,
        id: "nicole_stock",
        hero: (ASSETS_BASE_URL + "team/nicole.jpg"),
        title: "Software Engineer",
        email: "",
        github: "https://github.com/NEStock"
    },

    erik_johnson: {
        name: "Erik Johnson",
        public: true,
        id: "erik_johnson",
        hero: (ASSETS_BASE_URL + "team/erik.jpg"),
        title: "Software Engineer",
        email: "",
        github: "https://github.com/erikjohnson24"
    },

    nicole_guittari: {
        name: "Nicole Guittari",
        public: true,
        id: "nicole_guittari",
        hero: (ASSETS_BASE_URL + "team/nicoleg.jpg"),
        title: "Research Scientist",
        email: "",
        github: "https://github.com/guittari"
    },

    pat_rivlin: {
        name: "Pat Rivlin",
        public: true,
        id: "pat_rivlin",
        hero: (ASSETS_BASE_URL + "team/patr.jpg"),
        title: "Neuroanatomy Specialist",
        email: "",
        github: ""
    },

    akshita_panigrahi: {
        name: "Akshita Panigrahi",
        public: true,
        id: "akshita_panigrahi",
        hero: (ASSETS_BASE_URL + "team/akshita_panigrahi.jpg"),
        title: "Software Engineer",
        email: "",
        github: "https://github.com/akshitapanigrahi"
    },

    grace_bezold: {
        name: "Grace Bezold",
        public: true,
        id: "grace_bezold",
        hero: (ASSETS_BASE_URL + "team/grace_bezold.jpg"),
        title: "Research Engineer",
        email: "",
        github: "https://github.com/gbezold1"
    }
}

const former_member = {
    dean_kleissas: {
        name: "Dean Kleissas",
        public: true,
        id: "dean_kleissas",
        hero: (ASSETS_BASE_URL + "team/dean.jpg"),
    },
    joe_downs: {
        name: "Joe Downs",
        public: true,
        id: "joe_downs",
        hero: (ASSETS_BASE_URL + "team/jtpdowns.jpg"),
    },
    derek_pryor: {
        name: "Derek Pryor",
        public: true,
        id: "derek_pryor",
        hero: (ASSETS_BASE_URL + "team/pryordm1_LThumb.jpg"),
    },
    luis_rodriguez: {
        name: "Luis M. Rodriguez",
        public: true,
        id: "luis_rodriguez",
        hero: (ASSETS_BASE_URL + "team/luis_rodriguez.jpg"),
    },
    perry_wilson: {
        name: "Perry Wilson",
        public: true,
        id: "perry_wilson",
        hero: (ASSETS_BASE_URL + "team/perry.jpg"),
    },
    marisel_villafane_delgado: {
        name: "Marisel Villafane-Delgado",
        public: true,
        id: "marisel_villafane_delgado",
        hero: (ASSETS_BASE_URL + "team/marisel.jpg"),
    },
    stephen_farris: {
        name: "Stephen Farris",
        public: true,
        id: "stephen_farris",
        hero: (ASSETS_BASE_URL + "team/Farris-headshot.jpg"),
    },
    lindsey_kitchell: {
        name: "Lindsey Kitchell",
        public: true,
        id: "lindsey_kitchell",
        hero: (ASSETS_BASE_URL + "team/lindsey.jpg"),
    },
    morgan_sanchez: {
        name: "Morgan Sanchez",
        public: true,
        id: "morgan_sanchez",
        hero: (ASSETS_BASE_URL + "team/morgan.jpg"),
    },
    dymon_moore: {
        name: "Dymon Moore",
        public: true,
        id: "dymon_moore",
        hero: (ASSETS_BASE_URL + "team/dymon.jpg"),
    },
    kevin_romero: {
        name: "Kevin Romero",
        public: true,
        id: "kevin_romero",
        hero: (ASSETS_BASE_URL + "team/Romero.jpg"),
    },
    tori_rose: {
        name: "Tori Rose",
        public: true,
        id: "tori_rose",
        hero: (ASSETS_BASE_URL + "team/tori.jpg"),
    },
    devin_ramsden: {
        name: "Devin Ramsden",
        public: true,
        id: "devin_ramsden",
        hero: (ASSETS_BASE_URL + "team/devin.jpg"),
    },
    christa_cooke: {
        name: "Christa Cooke",
        public: true,
        id: "christa_cooke",
        hero: (ASSETS_BASE_URL + "team/christa.jpg"),
    }
}
export default {team_member, former_member};
